import React from "react";
import classes from "./footer.scss";

const OLLYO = { label: "Ollyo", domain: "ollyo.com" };
// Ollyo's other products
const PRODUCTS = [
  { label: "Kirki", domain: "kirki.com" },
  { label: "Tutor LMS", domain: "tutorlms.com" },
  { label: "JoomShaper", domain: "www.joomshaper.com" },
];

const OllyoLink = ({ site }) => (
  <a href={`https://${site.domain}/?utm_source=icofont&utm_medium=footer`} target="_blank" rel="noopener noreferrer">
    {site.label}
  </a>
);

// One line: the copyright and who makes IcoFont, then Ollyo's other products
export const Footer = () => (
  <footer className={classes.footer}>
    <div className={classes.inner}>
      <p>
        &copy;2015 – {new Date().getFullYear()} IcoFont. A product of <OllyoLink site={OLLYO} />.
      </p>
      <p className={classes.products}>
        More from Ollyo:{" "}
        {PRODUCTS.map((site, index) => (
          <React.Fragment key={site.domain}>
            {index ? <span aria-hidden="true">{" · "}</span> : null}
            <OllyoLink site={site} />
          </React.Fragment>
        ))}
      </p>
    </div>
  </footer>
);

export default Footer;
